import { render, staticRenderFns } from "./LiveTradeTabs.vue?vue&type=template&id=41184668&scoped=true"
import script from "./LiveTradeTabs.vue?vue&type=script&lang=js"
export * from "./LiveTradeTabs.vue?vue&type=script&lang=js"
import style0 from "./LiveTradeTabs.vue?vue&type=style&index=0&id=41184668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41184668",
  null
  
)

export default component.exports